import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";

/**
 * Shown when a user with cleaner role signs in.
 * Cleaners no longer use the app dashboard; they access properties via the token-gated link from the owner.
 */
export default function CleanerUsePortalLink() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/30">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Link2 className="w-5 h-5" />
            {t("useYourCleaningLink")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{t("useCleaningLinkHint1")}</p>
          <p className="text-sm text-muted-foreground">{t("useCleaningLinkHint2")}</p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">{t("backToSignIn")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
